import React from "react";
import Orders from "./Orders";
import "./History.css";

function HistoryIndex() {
  return (
    <div className="history">
      <Orders />
    </div>
  );
}

export default HistoryIndex;
